import { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { LoadingScreen, OverlaySidebar } from '@lendica/components';
// import { useAppContext } from '../hooks/useContext';
import { PdfViewer } from '../components/PdfViewer';
import { InvoiceSummary } from './InvoicePdfViewer';
import { useFundnowApi } from '../api';
import { Invoice } from '@lendica/utils';
import { RowType } from '../sharedTypes';

export const InvoicePdfViewerResponsive: FC<{
    collapsible?: boolean;
}> = ({ collapsible }) => {
    const { id, type } = useParams<{ id: string; type: RowType }>();
    const [filename, setFilename] = useState<string | null>(null);
    const [invoice, setInvoice] = useState<Invoice | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const api = useFundnowApi();
    // const appContext = useAppContext();

    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                setFilename(null);

                if (type === RowType.Invoice) {
                    const data = await api.getInvoiceByID(id!);
                    setInvoice(data);
                    setFilename(data.filename);
                } else {
                    setFilename((await api.getDealByID(id!)).filename);
                }
            } catch (e) {
                console.log(e);
            } finally {
                setTimeout(() => {
                    setLoading(false);
                }, 100);
            }
        })();
    }, [id]);

    const content =
        filename !== null && filename!.length > 0 ? (
            <PdfViewer invoices={[{ name: '', filename }]} />
        ) : (
            <InvoiceSummary invoice={invoice} />
        );

    if (loading) {
        return <LoadingScreen />;
    }

    // Use OverlaySidebar for dashboard, SidePanelLayout for iBranch
    // if (appContext === 'dashboard') {
    return (
        <OverlaySidebar redirectRoute="/fundnow" loading={loading} open={true}>
            {content}
        </OverlaySidebar>
    );
    // }

    // iBranch context - use existing SidePanelLayout
    // return (
    //     <SidePanelLayout redirectRoute="/fundnow" collapsible={collapsible} loading={loading}>
    //         {content}
    //     </SidePanelLayout>
    // );
};
